// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteButton_container__ayIlD","delete":"DeleteButton_delete__1XDKg","text":"DeleteButton_text__357j_","actions":"DeleteButton_actions__1Uuuc"};